import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ClassifierListItem, UpdateClassifierRequest } from 'types/classifier.interface';
import { AbstractControl, FormBuilder, FormsModule, Validators, ReactiveFormsModule } from '@angular/forms';
import { SpinnerComponent } from 'components/spinner/spinner.component';
import { BaseFormModalComponent } from '../base-form-modal.component';
import { ToastService } from 'services/toast.service';
import { NgClass } from '@angular/common';
import { getControlsWithErrors, MAX_LENGTH_NAME } from 'util/form.utility';

@Component({
  selector: 'app-edit-classifier',
  standalone: true,
  imports: [TranslateModule, FormsModule, SpinnerComponent, ReactiveFormsModule, NgClass],
  templateUrl: './edit-classifier.component.html',
  styleUrl: './edit-classifier.component.scss'
})
export class EditClassifierComponent extends BaseFormModalComponent implements OnInit {
  @Input() classifier!: ClassifierListItem;
  @Output() save: EventEmitter<UpdateClassifierRequest> = new EventEmitter<UpdateClassifierRequest>();

  get name(): AbstractControl<any, any> | null {
    return this.form.get('name');
  }

  constructor(
    formBuilder: FormBuilder,
    config: NgbModalConfig,
    modalService: NgbModal,
    toastService: ToastService,
    translateService: TranslateService
  ) {
    super(formBuilder, config, modalService, toastService, translateService);
  }

  ngOnInit() {
    this.fillForm();
  }

  fillForm(): void {
    this.form = this.formBuilder.group({
      name: [this.classifier.name, [Validators.required, Validators.maxLength(MAX_LENGTH_NAME)]]
    });
  }

  handleSave() {
    if (this.form.valid) {
      this.submitAttempted = false;
      this.save.emit({
        ...this.classifier,
        name: this.name?.value
      });
    } else {
      this.submitAttempted = true;
      this.toastService.showFormValidationError(getControlsWithErrors(this.form), 'components.editClassifierGroup');
    }
  }

  resetForm(): void {
    this.name?.setValue(this.classifier.name);
  }

  protected override close(): void {
    this.resetForm();
    super.close();
  }
}
